import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';

import Dialog from './index';
import { DialogActions } from 'components';
import DialogContent from '../Dialogs/DialogContent/Index';
import { AnimatedDialog } from '../animations';

export function FormDialog(props) {
  const {
    children,
    actions,
    initialValues,
    validate,
    onSubmit,
    contentStyle,
    onClose,
    mutators = {},
    actionsPosition = 'center',
    ...rest
  } = props;

  return (
    <AnimatedDialog {...rest} onClose={onClose} isFormDialog={true}>
      <Form
        mutators={mutators}
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validate}
        render={(form) => {
          return (
            <form onSubmit={form.handleSubmit} noValidate>
              <DialogContent style={contentStyle}>
                {children && children(form.values, form)}
              </DialogContent>
              {actions ? (
                <DialogActions sx={{ justifyContent: actionsPosition }}>
                  {actions}
                </DialogActions>
              ) : (
                ''
              )}
            </form>
          );
        }}
      />
    </AnimatedDialog>
  );
}

export default FormDialog;
